import { get } from 'lodash-es';
import { memo } from 'react';

import { useStoreSelector } from '@hook/store/store.hooks';
import { CredentialInterface } from '@interface/credential/credential.interface';

export const CredentialsUser = memo((props: Pick<CredentialInterface, 'user'>) => {
  const profile = useStoreSelector((state) => state.user.data.profile);

  return (
    <span>
      {get(props, ['user', 'profile', 'name'], get(profile, 'name', ''))}{' '}
      {get(props, ['user', 'profile', 'lastname'], get(profile, 'lastname', ''))}
    </span>
  );
});
